import React, { useRef } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  Text,
  HStack,
  AlertDialogOverlay,
  Button,
  Heading,
  Box
} from '@chakra-ui/react'
import { CheckCircle } from 'react-feather'

interface IBalertProps {
  isOpen: boolean
  onClose:  () => void
  onButtonClick?: () => void
  title?: string
  text: string
  textButton?: string
  variant?: string
  buttonClose?: boolean
  type?: string
  isIcon?: boolean
}

const typeAlertTheme = {
  info: {
    bgCustome: 'linear-gradient(181.08deg, rgba(232, 224, 249, 0.7) -27.55%, rgba(232, 224, 249, 0) 205%), #FFFFFF;',
    borderCustome: 'solid 1px #9E8ABD',
    sizeTitle: '20px',
    widthCustome: '779px',
    paddingCustome: '30px',
    closeColor: 'primary.30'
  },
  error: {
    bgCustome: '#FFDDE5',
    borderCustome: 'solid 1px #CF0031',
    sizeTitle: '14px',
    widthCustome: '581px',
    paddingCustome: '18px',
    closeColor: '#CF0031',
  },
  success: {
    bgCustome: 'success.95',
    sizeTitle: '14px',
    widthCustome: '581px',
    paddingCustome: '18px',
    closeColor: 'success.30',
    borderCustome: 'solid 1px #00513A',
  },
}

const icon = {
  success: <CheckCircle size={22} stroke='#00513A' data-testid='icon' />
}

const IBalert: React.FC<IBalertProps> = ({ isOpen, onClose, onButtonClick, title, text, textButton, variant = 'sm', buttonClose, type = 'info', isIcon = false }) => {
  const cancelRef = useRef(null)
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay bg='none'>
        <AlertDialogContent
          maxW={typeAlertTheme[type].widthCustome}
          bg={typeAlertTheme[type].bgCustome}
          borderRadius='12px'
          border={typeAlertTheme[type].borderCustome}
          boxShadow='none'
        >
          { buttonClose && <AlertDialogCloseButton mb={2} data-testid='alertCloseButton' color={typeAlertTheme[type].closeColor} _focusVisible={{ boxShadow: 'none' }} />}
          <AlertDialogBody p={typeAlertTheme[type].paddingCustome}>
            <HStack
              spacing='24px'
              justifyContent='space-around'
            >
              { isIcon && 
                <Box>{icon[type]}</Box>
              }
              <Box w='100%'>
                <Heading data-testid='alertTitle' as='h1' fontSize={typeAlertTheme[type].sizeTitle} lineHeight='20px' fontWeight='700'>{title}</Heading>
                <Text data-testid='alertBody' textStyle='bodyMediumRegular' mt={2}>
                  {text}
                </Text>
              </Box>
              {textButton &&
                <Box w='75px'>
                  <Button data-testid='alertButton' variant={variant} onClick={onButtonClick} w={variant !== 'linkPurple' ? '58px':''} p='0' mt={2}>
                    {textButton}
                  </Button>
                </Box>
              }
            </HStack>
          </AlertDialogBody>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default IBalert
